<template>
  <div id="externalPolicy">

    <div class="vo-external-card">
      <vo-external-header :title="title"></vo-external-header>

      <div class="vo-body">
        <div class="vo-title">{{ title }}</div>


        <p>Thank you for using Vilio.  We at Vilio (hereinafter referred to as "Vilio" / "we"/ "us"), (which expression shall include its successors and assigns) will handle all user information concerned with the App's Vilio service and all its related services (hereinafter referred to collectively as the 'Service') in accordance with the following.</p>
        <p> </p>
        <p><strong>Acquired Information and Scope of Use</strong></p>
        <p>Vilio shall use and acquire user information in the following ways:<p> 
        <p></p>
        <p><strong>User Information </strong></p>
        <p>When creating a new account, the name, email address, password and address will be used for the following aims and purposes:<p> 
        <p></p>

        <div class="tabbed">
          <p><strong>1. </strong> Email addresses and passwords registered for the purpose of using the Multi-device function will be used for identification purposes as well as to prevent any unauthorized use of the Service. Users may receive updates from the application via email including password change information. The email and password cannot be accessed by other users. </p>
          <p></p>
          <p>In order to carry-over an existing Service account onto another device, or to use the features which allow users to access the same Service account on multiple devices (hereinafter referred to as 'Multidevice function'), the users must register an email address and to configure a password.</p>
          <p></p>
          <p>When a Service account is deleted, Vilio shall delete all such user information in accordance with Vilio's regulations.</p>
          <p></p>

          <p><strong>2. </strong> Addresses will be used to determine the content displayed to the user. Depending on the address, the user will have access to different information pertaining directly to the property in which they live. This includes displaying the different amenities for a building, the other tenants, managers and developers for a building, and methods to interact with the users of a building. </p>
          <p></p>

            <p><strong>3. </strong> Users must provide their full name in order to use the site. Vilio requires full names in order to promote a sense of trust. Names will be displayed whenever the user makes maintenance tickets or chat with managers. </p>
          <p></p>
        </div>

        <p><strong>User Contact Information</strong></p>
        <p>Vilio acquires user information including phone number, email address, device type, and OS type etc., to help establish the user's identity, for examination into reported problems and to provide an appropriate response to those inquiries.<p> 
        <p></p>
        <p></p>

        <p><strong>Use of the Service</strong></p>
        <p></p>
        <p><strong>Cookies</strong></p>
        <p>To provide the best possible service to users, as well as for maintenance and security purposes, Cookies will be used to store user settings, to record access figures as well as monitoring usage patterns and statistics. Users can choose to deactivate Cookies, however in such circumstances users will not be able to use parts of the Service which require Cookies to be active such as those requiring users to login.<p> 
        <p></p>

        <p><strong>Logs</strong></p>
        <p>Upon access to the Service, the user's IP address, browser type, and browser language etc., will be automatically obtained and stored. Such information will be used to analyze user environments, thereby enabling Vilio to provide a better Service, as well as to prevent any unauthorized/fraudulent practices which interfere with normal Service operations.<p> 
        <p></p>

        <p><strong>Location Information</strong></p>
        <p>Some of the Services may use location information transmitted from users' mobile phones/devices. Vilio only uses such information within the scope that is necessary in order to provide the designated service. When users have not allowed their location information to be sent via the settings menu on their devices, location information will not be sent.<p> 
        <p></p>

        <p><strong>Device Information</strong></p>
        <p>The users' device information (OS type, serial number, PC hardware information etc.) may be acquired at times. This information shall be used for the provision of a better service, as well as for identification purposes and prevention of any unauthorized/fraudulent practices which interfere with normal Service operations.<p> 
        <p></p>
        <p></p>

        <p><strong>Purpose of User Information</strong></p>
        <p>Regarding the scope of usage, if usage rules and limitations have already been determined upon collection of a particular set of user information, the information concerned shall only be used in accordance with the scope of that particular function. For all other cases, Vilio shall use the acquired personal information for the following purposes listed below:<p> 
        <p></p>

        <ul>
          <li><p>To prevent any unauthorized/fraudulent use of the Service.</p></li>
          <li><p>To offer an undisturbed and smooth Service to users.</p></li>
          <li><p>To aggregate statistical data regarding the Service.</p></li>
          <li><p>To conduct research and analysis aimed at reviewing and improving Services. </p></li>
          <li><p>To enable Vilio to deal effectively with user inquiries.</p></li>
          <li><p>To provide information regarding the Service etc., as well as advertising information from our partner businesses.</p></li>
          <li><p>To provide new future developments regarding the Service.</p></li>
          <li><p>To perform identity checks when a user makes an inquiry etc.</p></li>
          <li><p>To notify users of any other important information regarding the Service and to contact users where necessary.</p></li>
        </ul> 

        <p></p>
        <p><strong>Provision of Information</strong></p>
        <p>Vilio will never provide user information to any third parties without the user`s consent, unless Vilio is obliged and/or permitted to do so under applicable laws.<p> 
        <p></p> 

        <p><strong>Information Delegation</strong></p>
        <p>Vilio may entrust, to the extent Vilio considers necessary to achieve the intended purpose concerning the use of the Service, the handling of personal information collected from users, in whole or in part, to a trustee. In such circumstances, the Vilio will adequately assess the eligibility of the trustee, impose a confidentiality agreement upon the trustee, and establish an appropriate information administration system.<p> 
        <p></p> 

        <p><strong>Shared Use of Information</strong></p>
        <p>Vilio may share the user's personal information with a business partner, when a business partner's cooperation is needed in order to keep providing the Service to the user. In such circumstances, Vilio will inform the user regarding the purpose of information sharing, the name of the business partner and information manager, as well as the type of shared information involved before sharing the user's personal information with such a business partner.<p> 
        <p></p> 

        <p><strong>Measurement of Advertising Effectiveness</strong></p>
        <p>Since Vilio shall pay expenses to advertising agencies for Service advertisements published in other media, Vilio may install thirdparty modules within the smartphone versions of the Service application in order to measure the effectiveness of the advertising. Details regarding which applications the third-party modules will be installed on etc., can be viewed here. User Rights Users may, at any time, confirm or correct their registered personal information such as email address and/or password on the Service. Users can also delete their accounts. Users may, through the procedures determined by the Vilio, send Vilio a request for the disclosure of personal information which the users cannot confirm/access via the Service. Vilio, in turn shall disclose such information except under the following conditions:<p> 
        <p></p> 

          <ul>
          <li><p>When the disclosure is likely to harm the life, body, property or other rights or interests of the user or any other third party.</p></li>
          <li><p>When the disclosure is likely to severely interfere with the Vilio's proper operation.</p></li>
          <li><p>When disclosure itself would constitute a violation of laws and/or regulations.</p></li>
          <li><p>When Vilio is unable to verify the user's ownership of the personal information requested for disclosure. After the disclosure, users may, through the procedures determined by Vilio, send Vilio a request to correct, add or delete the user's personal information, if the users find personal information registered with Vilio to be incorrect. Under such circumstances, Vilio shall swiftly investigate the request to achieve the desired user intention and correct, add or delete the personal information on the basis of Vilio's findings.</p>
          <p></p>
          <p>When users request the disclosure by Vilio of their personal information that is unable to be confirmed/accessed through the Service, Vilio may charge the users a certain fee for the disclosure procedures. The users can choose freely whether or not they will provide Vilio with their personal information, however the users may be unable to use a part of the Service until they have provided Vilio with the necessary information.</p>  
          </li>
        </ul> 
        <p></p>

        <p><strong>Withdrawal from Our Services</strong></p>
        <p>Upon withdrawing from our Services, when a user account is deleted, all user information will be disposed of in the correct manner in accordance with the law and Vilio regulations.<p> 
        <p></p> 

        <p><strong>A Special Note about Children</strong></p>
        <p>Our Service is intended for a general audience and is not directed to or intended be used by children. We understand the special necessity to protect children's online privacy, and we do not knowingly collect any personal information from children. If, however, you believe we have collected any personal information from children, then please let us know by email at <strong>vilio@zomaron.com</strong>. If we learn that we have inadvertently collected personal information from children, then we will deactivate that account and take reasonable measures to promptly delete such personal information from our records. If you have any questions or comments about our policy to protect children's online privacy, please contact us at <strong>vilio@zomaron.com</strong><p> 
        <p></p> 

        <p><strong>Modifications to this Privacy Policy</strong></p>
        <p>This Privacy Policy may be revised periodically. Users will be notified of important changes in a recognizable manner.Inquiries If users have any uncertainty about this Privacy Policy or questions, complaints, or comments on the handling of personal information related to the Service, users are asked to contact us at <strong>vilio@zomaron.com</strong><p> 
        <p></p> 

      </div>

    </div>

  </div>
</template>


<script>

  export default {
    data () {
      return {
        title: 'Terms of Service & Privacy Policy'
      }
    },

    computed: {

      version () {
        return VERSION;
      },

      feedbackUrl () {
        return EXTERNAL_URLS.feedback.resident;
      }

    }
  }

</script>

<style lang="scss">

  @import '../css/global.scss';

  #externalPolicy {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    @include scrollable;

    a {
      color: $primary;
    }
    

    ul {
      padding-left: 40px;
    }

    p {
      color: rgba(0,0,0,.87);
    }

    .tabbed {
      margin-left: 16px;
    }

  }

  @media screen and (max-width: 780px) {
  
    #externalPolicy {
    
      background: $lightGreen !important;
    }
  }

</style>


// WEBPACK FOOTER //
// src/components/ExternalPolicy.vue